var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../libs/dragscroll');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var modal = require('../layout/components/modal');
var edit = require('../layout/components/edit');
var auth = require('../auth/models/session');
var modalForm = require('../layout/components/modalForm');
var modbusDevice = require('./models/modbusDevice');
var modbusAddress = modalForm(require('./models/modbusAddress'));
var pollGroup = modalForm(require('./models/pollGroup'));
var networkTreeTransferModal = require('../network/treeTransferModal');
var modelDetail = require('../components/modelDetail');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var rowActionDropdown = require('../components/rowActionDropdown');
var tableColumns = require('../network/components/tableColumns');
var pageTitle = require('../layout/pageTitle');
var page = {};

var TWO_PWR_32 = Math.pow(2, 32);

function formatCellValue (value) {
  if (value === null || typeof value === 'undefined') {
    return '';
  }
  if (Array.isArray(value)) {
    return value.map(formatCellValue).join(', ');
  }
  if (typeof value === 'object') {
    if (Object.prototype.hasOwnProperty.call(value, 'value')) {
      return formatCellValue(value.value);
    }
    var hasLow = Object.prototype.hasOwnProperty.call(value, 'low');
    var hasHigh = Object.prototype.hasOwnProperty.call(value, 'high');
    if (hasLow || hasHigh) {
      var low = hasLow ? Number(value.low) : 0;
      var high = hasHigh ? Number(value.high) : 0;
      if (!Number.isNaN(low) && !Number.isNaN(high)) {
        return String((high * TWO_PWR_32) + low);
      }
    }
    if (typeof value.toString === 'function' && value.toString !== Object.prototype.toString) {
      return value.toString();
    }
    return JSON.stringify(value);
  }
  return String(value);
}

function actionDropdown(items) {
  return m(rowActionDropdown, {
    position: 'fixed',
    align: 'left',
    buttonStyle: {
      minWidth: '1.6rem',
      paddingTop: '0.05rem',
      paddingBottom: '0.12rem',
      paddingLeft: '0.18rem',
      paddingRight: '0.18rem',
      lineHeight: '1'
    },
    items: items
  });
}

function groupRowActions(group) {
  return [
    {
      label: 'Edit ' + group.name,
      icon: 'ion-ios-compose',
      onclick: function () { pollGroup.editDialogue(group); }
    },
    {
      label: 'Delete ' + group.name,
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { pollGroup.deleteDialogue(group); }
    }
  ];
}

function renderGroupNameCell(group) {
  return m('div.flex.items-center.justify-between', [
    m('span', group.name),
    m('div.ml3.flex-none', [
      actionDropdown(groupRowActions(group))
    ])
  ]);
}

function addressRowActions(children) {
  return [
    {
      label: 'Edit ' + children.name,
      icon: 'ion-ios-compose',
      onclick: function () { modbusAddress.editDialogue(children); }
    },
    {
      label: 'Delete ' + children.name,
      icon: 'ion-ios-trash',
      class: 'red',
      onclick: function () { modbusAddress.deleteDialogue(children); }
    }
  ];
}

function renderAddressNameCell(children, url) {
  return m('div.flex.items-center.justify-between', [
    m(m.route.Link, { href: url }, children.name),
    m('div.ml3.flex-none', [
      actionDropdown(addressRowActions(children))
    ])
  ]);
}

page.oninit = function (vnode) {
  var ctrl = this;
  header.vm.activeTab(vnode.attrs.activeTab);
  pageTitle.set(null, { fallback: modbusDevice.name });
  ctrl.newNodeGroups = prop(false);
  ctrl.newNodeChildren = prop(false);
  ctrl.init = function () {
    ctrl.getBranch();
    ctrl.getGroups();
  };

  ctrl.getBranch = function () {
    var url = '/api/v1/modbusDevice/';
    if (m.route.param('id')) { url += m.route.param('id')};
    loaders.requestWithLoader({
      url: url,
      method: 'GET'
    })
    .then(function(result){
      ctrl.record = result;
      pageTitle.set(ctrl.record, { fallback: modbusDevice.name });
      ctrl.newNodeChildren(true);
    });
  }

  ctrl.getGroups = function () {
    if (m.route.param('id')) { 
      var url = '/api/v1/modbusdevice/' + m.route.param('id') + '/pollgroups/';
      loaders.requestWithLoader({
        url: url,
        method: 'GET'
      })
      .then(function(result){
        ctrl.groups = result;
        ctrl.newNodeGroups = prop(true);
      });
    }
  };

  ctrl.groupsToShow = [];
  ctrl.childrenToShow = [];

  modal.on('closed', ctrl.init);

  
  ctrl.init();
};

page.onremove = function () {
  modal.off('closed', this.init);
};

page.view = function () {
  var ctrl = this
  if(!ctrl.record || !ctrl.groups){
    return m('div')
  }
  var gateway = ctrl.record.breadcrumbs[0];
  return m('div', [
    m('div.mh3.mb3.pb2.bb.bw1.b--mid-gray.near-white.flex.justify-between.items-center.display', [
      m('div.pb2.f-subheadline.fw5', [
        m('div.dib-ns.mr2', [
          m(m.route.Link, {href: '/networks'}, 'Networks'),
          ' / '
        ]),
        ctrl.record.breadcrumbs.slice(0, 1).map(function (ancestor, idx) {
          return m('div.dib-ns.mr2', [
            m(m.route.Link, {href: '/' + ancestor['@id'].split('/').slice(3).join('/').toLowerCase()}, ancestor.name),
            ' / '
          ])
        }),
        m('div.dib-ns.mr2', ctrl.record.name)
      ]),
      (function () {
        if(edit.vm.editing() && auth.user().isSuperuser == 1){
          return m(rowActionDropdown, {
            items: [
              {
                label: 'Edit ' + ctrl.record.name,
                icon: 'ion-ios-compose',
                onclick: () => modbusDevice.editDialogue(ctrl.record)
              },
              {
                label: 'Export Modbus Device',
                icon: 'ion-document-text',
                onclick: () => networkTreeTransferModal.openHostExportModal(gateway, [ctrl.record])
              },
              {
                label: 'New Poll Group',
                icon: 'ion-plus',
                onclick: () => pollGroup.editDialogue({parent:ctrl.record['@rid']})
              },
              {
                label: 'New Address',
                icon: 'ion-plus',
                onclick: () => modbusAddress.editDialogue({parent:ctrl.record['@rid']})
              }
            ]
          })
        }
      })(),
    ]),
    browse(ctrl)
  ]);
};


function browse (ctrl) {
    return m('div', [
      m('div', {class:'cf.mb3'}, [
        modelDetail(ctrl, modbusDevice),
      ]),
      m('div.mh3.mt3.mb2.bw1.pv1.tc.f3.bb', 'Groups'),
      m('div.cf', 
        m('div.mh3',[
          m(paginationWithSearch, {
            data: ctrl.groups,
            newNode: ctrl.newNodeGroups,
            dataToShow: ctrl.groupsToShow,
            placeHolder: 'Search',
            itemsPerPage: 10,
            fieldsToSearch: ['name']
          },[
            m('div.overflow-hidden',[
              m('div.dragscroll-container', [
                m('div.dragscroll', {oncreate:dragscroll}, [
		                  m('table.w-100.f4.mb4.mt2.mr4', [
		                    tableColumns.colgroup(['name', 'unitId', 'address', 'length']),
		                    m('thead', [
	                      m('tr', [
	                        m('th.ph0.tl', 'Name'),
	                        m('th.ph0.tl', 'Unit Id'),
	                        m('th.ph0.tl', 'Address'),
	                        m('th.ph0.tl', 'Length')
	                      ])
	                    ]),
                    m('tbody', [
                      ctrl.groupsToShow.map(group => {
                        if (!group['@rid']) {
                          return m('tr', [
	                            m('td.tl.nowrap',[
	                              m('label',{style:{'visibility':'hidden'}}, 'No Data')
	                            ]),
	                            m('td.tl.nowrap'),
	                            m('td.tl.nowrap'),
	                            m('td.tl.nowrap')
	                          ])
	                        } else {
	                          return m('tr', [
	                            m('td.tl.nowrap', renderGroupNameCell(group)),
	                            m('td.tl.nowrap', formatCellValue(group.unitId)),
	                            m('td.tl.nowrap', formatCellValue(group.address)),
	                            m('td.tl.nowrap', formatCellValue(group.length))
	                          ])
	                        }
                      })
                    ])
                  ])
                ])
              ])
            ])
            
          ])
        ])
      ),
      m('div.mh3.mt3.mb2.bw1.pv1.tc.f3.bb', 'Addresses'),
      m('div.cf', [
        m('div.mh3',[
          m(paginationWithSearch, {
            data: ctrl.record.children,
            newNode: ctrl.newNodeChildren,
            dataToShow: ctrl.childrenToShow,
            placeHolder: 'Search',
            itemsPerPage: 10,
            fieldsToSearch: ['name']
          },[
            m('div.overflow-hidden',[
              m('div.dragscroll-container', [
                m('div.dragscroll', {oncreate:dragscroll}, [
		                  m('table.w-100.f4.mb4.mt2.mr4', [
		                    tableColumns.colgroup(['name', 'type', 'address', 'length']),
		                    m('thead', [
	                      m('tr', [
	                        m('th.ph0.tl', 'Name'),
	                        m('th.ph0.tl', 'Type'),
	                        m('th.ph0.tl', 'Address'),
	                        m('th.ph0.tl', 'Length')
	                      ])
                      
                    ]),
                    m('tbody', [
                      ctrl.childrenToShow.map(children => {
                        if(!children['@id']){
                          return m('tr', [
	                            m('td.tl.nowrap',[
	                              m('label',{style:{'visibility':'hidden'}}, 'No Data')
	                            ]),
	                            m('td.tl.nowrap'),
	                            m('td.tl.nowrap'),
	                            m('td.tl.nowrap')
	                          ])
	                        }else{
	                          children.parent = ctrl.record['@rid'];
	                          let url = '/' + children['@id'].split('/').slice(3,5).join('/').toLowerCase();
	                          return m('tr', [
	                            m('td.tl.nowrap' , renderAddressNameCell(children, url)),
	                            m('td.tl.nowrap', children.type),
	                            m('td.tl.nowrap', formatCellValue(children.address)),
	                            m('td.tl.nowrap', formatCellValue(children.length))
	                          ])
	                        }
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  };

module.exports = page;
